import Vue from "vue";
import axios from "axios";
import {handleError} from "@/_helpers/utils";

export default {
  namespaced: true,
  state () {
    return {
      by_assessment_id: {}
    }
  },
  actions: {
    load (context, assessment_id) {
      const pdf_report_types = context.getters.get_pdf_report_types_by_assessment_id(assessment_id);
      if (pdf_report_types.loading || pdf_report_types.list) return Promise.resolve();
      context.commit('set_pdf_report_types_by_assessment_id', {assessment_id, data: {loading: true}});
      return axios.get(`/1.0/talentq/dictionary/pdf-report-types/${assessment_id}`)
        .then(response => response.data.data)
        .then(list => {
          context.commit('set_pdf_report_types_by_assessment_id', {assessment_id, data: {list}});
        })
        .catch(error => {
          error = handleError(error);
          context.commit(
            'set_pdf_report_types_by_assessment_id',
            {assessment_id, data: {error}}
          );
          throw error;
        })
    }
  },
  mutations: {
    set_pdf_report_types_by_assessment_id (state, {assessment_id, data}) {
      Vue.set(state.by_assessment_id, assessment_id, data);
    },
  },
  getters: {
    get_pdf_report_types_by_assessment_id: (state) => assessment_id => ({
      loading: false,
      error: null,
      list: null,
      ...(state.by_assessment_id[assessment_id] || {})
    }),
  }
}